export default {
  unavailable: {
    title: 'Self-serve partner access is limited',
    description:
      'This section is not available for partners on self-serve onboarding. Please contact your account manager if you need it.',
  },
};
